import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PaymentActivityTrackingDto } from '../../payment-activity-tracking/dtos/payment-activity-tracking.dto';
import { PaymentChannelEnum } from '../enums/payment-channel.enum';
import { PaymentMethodEnum } from '../enums/payment-method.enum';
import { PaymentProviderEnum } from '../enums/payment-provider.enum';
import { PaymentStatusEnum } from '../enums/payment-status.enum';

/**
 *  Payment record DTO
 */
@CaslSubject(AppSubjectEnum.PAYMENT)
export class PaymentRecordDto extends BaseDto {
  transactionIds?: number[] | null;
  provider!: PaymentProviderEnum;
  paymentMethod!: PaymentMethodEnum;
  channel!: PaymentChannelEnum;
  externalReference?: string | null;
  externalStatus?: string | null;
  status!: PaymentStatusEnum;
  paymentLink?: string | null;
  metadata?: Record<string, any> | null;
  currencyIsoCode!: string;
  amount?: number | null;
  retryCount?: number | null;
  activityTracking?: PaymentActivityTrackingDto[] | null;
  files?: FileDto[] | null;
}
